import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
// import { ToolbarComponent } from './toolbar/toolbar.component';
// import { NavbarComponent } from './navbar/navbar.component';
import { ControlMessagesComponent } from './utilities/control-messages.component';
// import { NameListService } from './name-list/name-list.service';
// import {AuthGuard} from './services/auth-guard.service';
import { ValidationService } from './utilities/validation.service';
import { DateTimeFormatPipe } from './utilities/app.dateformat.pipe';
import { DateFormatPipe } from './utilities/app.formatdate';
// import {dateTimeFormatGMT} from './utilities/app.dateformatGMT.pipe';

/**
 * Do not specify providers for modules that might be imported by a lazy loaded module.
 */
import { SuccessorComponent } from './components/successor/successor';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
@NgModule({
  imports: [CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMultiSelectModule],
  declarations: [
    //   ToolbarComponent, NavbarComponent, 
    ControlMessagesComponent,
    DateTimeFormatPipe,
    DateFormatPipe,
    SuccessorComponent
  ],

  exports: [
    //   ToolbarComponent, NavbarComponent, 
    ControlMessagesComponent, DateTimeFormatPipe, DateFormatPipe,
    CommonModule, FormsModule, RouterModule, ReactiveFormsModule, SuccessorComponent]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        //   NameListService, AuthGuard,
        ValidationService]
    };
  }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/shared.module.ts